<template>
    <div>
        <TopBar data-cy="component_home_topbar"></TopBar>
        <SideMenu data-cy="component_home_side_menu"></SideMenu>
        <div class="container mx-auto page p-3" data-cy="container_home_page">
            <div class="text-lg mt-5 text-gray-600" data-cy="text_home_title">{{lbl.home.title}}</div>
            <div class="text-lg font-bold mt-5 underline" data-cy="text_home_modal_heading">Modal</div>
            <div class="border p-3 text-white" data-cy="container_home_modal_buttons">
                <button class="bg-blue-600 py-1 px-3 font-bold rounded-md mr-3" @click="openAlertModal()" data-cy="btn_home_open_alert_modal">Alert Modal</button>
                <button class="bg-blue-600 py-1 px-3 font-bold rounded-md mr-3" @click="openConfirmModal()" data-cy="btn_home_open_confirm_modal">Confirm Modal</button>
                <button class="bg-blue-600 py-1 px-3 font-bold rounded-md mr-3" @click="openLoadingModal()" data-cy="btn_home_open_loading_modal">Loading Modal</button>
            </div>
            <FormLogin :modalController="modalController" data-cy="component_home_form_login"></FormLogin>
            <UserInfo :modalController="modalController" data-cy="component_home_user_info"></UserInfo>

            <div class="border p-3 mt-3" data-cy="container_home_state_management">
                <div class="text-lg font-bold" data-cy="text_home_state_management_title">State management</div>
                <div data-cy="text_home_count">Count: {{count}}</div>
                <StoreCountControl data-cy="component_home_store_count_control"></StoreCountControl>
            </div>
        </div>
        <ModalMaster :controller="modalController" data-cy="component_home_modal_master"></ModalMaster>
    </div>
</template>
<script>
//helper
import ConfigManager from "@/config/ConfigManager.js";
import CacheHepler from "@/helper/CacheHelper.js";
//component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import SideMenu from "@/components/Layout/SideMenu/SideMenu.vue";
import FormLogin from "../component/FormLogin.vue";
import UserInfo from "../component/UserInfo.vue";
import StoreCountControl from "../component/StoreCountControl.vue";
//mixin
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//store
import CountStore from "@/store/CountStore.js";

export default {
    name: "Home",
    mixins: [ModalMixin, LocaleMixin, AuthStatusMixin],
    provide: {
        CountStore: CountStore
    },
    components: {
        TopBar,
        SideMenu,
        FormLogin,
        UserInfo,
        StoreCountControl,
    },
    computed: {
        count: function() {
            return CountStore.state.count;
        },
    },
    created: function() {
        console.log(ConfigManager.getAppId());
        let cache = new CacheHepler(this, 'cookie');
        cache.setCache("test_cache", { 'msg': '1234' });

        // this.tracking.screenName("Hello world");
        // this.tracking.event("home", "view", "label_home", "1234");
    },
    methods: {
        openAlertModal: function() {
            this.alertModal.clearModal()
                    .setTitle("alert title")
                    .setMsg("message")
                    .show();
            this.alertModal.onClickOk(() => {
                console.log("click alert ok");
            })
        },
        openConfirmModal: function() {
            this.confirmModal.clearModal()
                    .setTitle("Confirm modal")
                    .setMsg("Confirm message")
                    .show();
            this.confirmModal.onClickOk(() => {
                console.log("click confirm ok");
            });
            this.confirmModal.onClickCancel(() => {
                console.log("click confirm cancel");
            });
        },
        openLoadingModal: function() {
            this.loadingModal.show();
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
